module.exports = __webpack_public_path__ + "img/login.4c6e4014.svg";